const footerHu = {
    "follow_us": "Kövess minket!",
    "all_rights_reserved": "2024 Code Kitchen Kft all right reserved",
    "terms_and_conditions": "Adatvédelmi Szerződési feltételek",
    "privacy_policy": "Adatvédelmi nyilatkozat",
}

export default footerHu;